import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import StorageService from "../services/StorageService";
import NotificationService from "../services/notificationService";
export default function Header() {

  const navigate = useNavigate();
  const location = useLocation();
  const isDashboard = location.pathname.includes("dashboard");
  const [headerTitle, setHeaderTitle] = useState(() => sessionStorage.getItem("dashboardHeaderTitle") || "");

  useEffect(() => {
    const handleTitleUpdate = (e) => {
      if (e.detail !== undefined) {
        setHeaderTitle(e.detail);
      }
    };
    window.addEventListener("dashboardHeaderTitleUpdate", handleTitleUpdate);
    return () => window.removeEventListener("dashboardHeaderTitleUpdate", handleTitleUpdate);
  }, []);

  const company = localStorage.getItem("selectedCompany");
  
  const [notifications, setNotifications] = useState([]);
const [notifOpen, setNotifOpen] = useState(false);
const notifRef = useRef(null);
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);
  const [user] = useState(() => StorageService.loginData() || {});
  const roleId = user?.roleId;
  const switchCompany = async (data) => {
    localStorage.setItem("selectedCompany", "");
    navigate("/company-selection")
  };

useEffect(() => {
  const fetchNotifications = async () => {
    try {
      const currentUser = StorageService.loginData();

      // const userId =
      //   currentUser?.userId ||
      //   currentUser?.id ||
      //   currentUser?.Id;
      const userId = currentUser?.employeeId;

      if (!userId) return;

      const res = await NotificationService.getByUserId(userId);

      console.log("Notifications API:", res);

      if (res?.status) {
        setNotifications(res.data || []);
      } else {
        setNotifications([]);
      }
    } catch (err) {
      console.error("Notification Error:", err);
    }
  };

  // 🔥 Initial Load
  fetchNotifications();

  // 🔥 Auto Refresh every 5 sec
  const interval = setInterval(fetchNotifications, 5000);

  return () => clearInterval(interval);
}, []);
  

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (notifRef.current && !notifRef.current.contains(event.target)) {
      setNotifOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  const handleLogout = () => {
    setProfileOpen(false);
    localStorage.clear();
    navigate("/", { replace: true });
  };

  // const handleChangePassword = () => {
  //   const menu = document.getElementById("userProfileMenu");
  //   if (menu && menu.classList.contains("show")) {
  //     menu.classList.remove("show");
  //   }
  //   setProfileOpen(false);
  //   navigate("/cpnl/change-password");
  // };

  const handleChangePassword = () => {
    setProfileOpen(false);
    navigate("/cpnl/change-password");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileRef.current &&
        !profileRef.current.contains(event.target)
      ) {
        setProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <header id="mainHeader" className="pc-header">
      <div className="header-wrapper">
        <div className="me-auto pc-mob-drp">
          <div className="list-unstyled nav">
            <div className="pc-h-item pc-sidebar-collapse nav-item">
              <a
                id="sidebar-hide"
                className="pc-head-link ms-0 nav-link"
                href="#"
                data-discover="true"
              >
                <i className="ph ph-list" />
              </a>
            </div>
            <div className="pc-h-item dropdown" >
              {company && (
                <span className="fw-bold" style={{ fontSize: "1.2rem" }}>
                  {company}
                </span>
              )}
              {(roleId === 1 || roleId === "1") &&
                <button
                  type="button"
                  id="user-profile-dropdown"
                  aria-expanded="false"
                  aria-haspopup="true"
                  className="pc-head-link arrow-none me-0 dropdown-toggle btn btn-link"
                  onClick={switchCompany}
                  title="Click to switch the company"
                >
                  <i className="ph ph-arrow-u-up-left" />
                </button>}

            </div>
            {/* <div className="pc-h-item pc-sidebar-popup nav-item">
              <a
                id="mobile-collapse"
                className="pc-head-link ms-0 nav-link"
                href="/demos/admin-templates/datta-able/react/free"
                data-discover="true"
              >
                <i className="ph ph-list" />
              </a>
            </div>
            <div className="pc-h-item dropdown dropdown">
              <button
                type="button"
                id="dropdown-search"
                aria-expanded="false"
                className="pc-head-link arrow-none m-0 trig-drp-search dropdown-toggle btn btn-link"
              >
                <i className="ph ph-magnifying-glass" />
              </button>
            </div> */}
          </div>
        </div>

        {/* 🔥 Dashboard Selected Category First Letter * Project Name Header Display */}
        {isDashboard && headerTitle && (
          <div className="d-none d-md-flex align-items-center justify-content-center mx-auto" style={{ flex: 1, minHeight: "60px" }}>
            <span className="fw-bold" style={{ fontSize: "1.2rem" }}>
              {headerTitle}
            </span>
          </div>
        )}

        <div className="ms-auto">
          <div className="list-unstyled nav">

            {/* <div className="pc-h-item dropdown">
              <button
                type="button"
                id="notification-dropdown"
                aria-expanded="false"
                className="pc-head-link me-0 arrow-none dropdown-toggle btn btn-link"
              >
                <i className="ph ph-bell" />
                <span className="badge bg-success pc-h-badge">3</span>
              </button>
              <div
                x-placement="bottom-end"
                aria-labelledby="notification-dropdown"
                className="dropdown-notification pc-h-dropdown dropdown-menu dropdown-menu-end"
                data-popper-reference-hidden="false"
                data-popper-escaped="false"
                data-popper-placement="bottom-end"
                style={{
                  position: "absolute",
                  inset: "0px 0px auto auto",
                  transform: "translate3d(-72.8889px, 1031.11px, 0px)",
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-between dropdown-header"
                  role="heading"
                >
                  <h5 className="m-0">Notifications</h5>
                  <a
                    className="btn btn-link btn-sm"
                    href="/demos/admin-templates/datta-able/react/free"
                    data-discover="true"
                  >
                    Mark all read
                  </a>
                </div>
                <div
                  style={{ flexGrow: 1, height: "100%", overflow: "hidden" }}
                >
                  <div
                    data-simplebar="init"
                    className=""
                    style={{ maxHeight: "calc(-215px + 100vh)" }}
                  >
                    <div className="simplebar-wrapper" style={{ margin: 0 }}>
                      <div className="simplebar-height-auto-observer-wrapper">
                        <div className="simplebar-height-auto-observer" />
                      </div>
                      <div className="simplebar-mask">
                        <div
                          className="simplebar-offset"
                          style={{ right: 0, bottom: 0 }}
                        >
                          <div
                            className="simplebar-content-wrapper"
                            tabIndex={0}
                            role="region"
                            aria-label="scrollable content"
                            style={{ height: "auto", overflow: "hidden" }}
                          >
                            <div
                              className="simplebar-content"
                              style={{ padding: 0 }}
                            >
                              <div className="dropdown-body text-wrap position-relative">
                                <p className="text-span">Today</p>
                                <div className="mb-0 card">
                                  <div className="card-body">
                                    <div className="hstack gap-3">
                                      <img
                                        src="/demos/admin-templates/datta-able/react/free/src/assets/images/user/avatar-1.png"
                                        alt="Generic placeholder image"
                                        className="img-radius avatar rounded-0"
                                      />
                                      <div>
                                        <span className="float-end text-sm text-muted">
                                          2 min ago
                                        </span>
                                        <h5 className="text-body mb-2">
                                          UI/UX Design
                                        </h5>
                                        <p className="mb-0">
                                          Lorem Ipsum has been the industry's
                                          standard dummy text ever since the
                                          1500s.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="mb-0 card">
                                  <div className="card-body">
                                    <div className="hstack gap-3">
                                      <img
                                        src="/demos/admin-templates/datta-able/react/free/src/assets/images/user/avatar-2.png"
                                        alt="Generic placeholder image"
                                        className="img-radius avatar rounded-0"
                                      />
                                      <div>
                                        <span className="float-end text-sm text-muted">
                                          1 hour ago
                                        </span>
                                        <h5 className="text-body mb-2">
                                          Message
                                        </h5>
                                        <p className="mb-0">
                                          Lorem Ipsum has been the industry's
                                          standard dummy text ever since the
                                          1500s.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <p className="text-span">Yesterday</p>
                                <div className="mb-0 card">
                                  <div className="card-body">
                                    <div className="hstack gap-3">
                                      <img
                                        src="/demos/admin-templates/datta-able/react/free/src/assets/images/user/avatar-3.png"
                                        alt="Generic placeholder image"
                                        className="img-radius avatar rounded-0"
                                      />
                                      <div>
                                        <span className="float-end text-sm text-muted">
                                          2 hour ago
                                        </span>
                                        <h5 className="text-body mb-2">
                                          Forms
                                        </h5>
                                        <p className="mb-0">
                                          Lorem Ipsum has been the industry's
                                          standard dummy text ever since the
                                          1500s.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="mb-0 card">
                                  <div className="card-body">
                                    <div className="hstack gap-3">
                                      <img
                                        src="/demos/admin-templates/datta-able/react/free/src/assets/images/user/avatar-4.png"
                                        alt="Generic placeholder image"
                                        className="img-radius avatar rounded-0"
                                      />
                                      <div>
                                        <span className="float-end text-sm text-muted">
                                          12 hour ago
                                        </span>
                                        <h5 className="text-body mb-2">
                                          Challenge invitation
                                        </h5>
                                        <p className="mb-0">
                                          Jonny aber invites you to join the
                                          challenge
                                        </p>
                                        <div className="mt-2">
                                          <button
                                            type="button"
                                            className="me-2 btn btn-outline-secondary btn-sm"
                                          >
                                            Decline
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                          >
                                            Accept
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="mb-0 card">
                                  <div className="card-body">
                                    <div className="hstack gap-3">
                                      <img
                                        src="/demos/admin-templates/datta-able/react/free/src/assets/images/user/avatar-5.png"
                                        alt="Generic placeholder image"
                                        className="img-radius avatar rounded-0"
                                      />
                                      <div>
                                        <span className="float-end text-sm text-muted">
                                          5 hour ago
                                        </span>
                                        <h5 className="text-body mb-2">
                                          Security
                                        </h5>
                                        <p className="mb-0">
                                          Lorem Ipsum has been the industry's
                                          standard dummy text ever since the
                                          1500s.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="simplebar-placeholder"
                        style={{ width: 0, height: 0 }}
                      />
                    </div>
                    <div
                      className="simplebar-track simplebar-horizontal"
                      style={{ visibility: "hidden" }}
                    >
                      <div
                        className="simplebar-scrollbar"
                        style={{ width: 0, display: "none" }}
                      />
                    </div>
                    <div
                      className="simplebar-track simplebar-vertical"
                      style={{ visibility: "hidden" }}
                    >
                      <div
                        className="simplebar-scrollbar"
                        style={{
                          height: 0,
                          transform: "translate3d(0px, 171px, 0px)",
                          display: "none",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="text-center py-2">
                  <a
                    className="link-danger"
                    href="/demos/admin-templates/datta-able/react/free#!"
                    data-discover="true"
                  >
                    Clear all Notifications
                  </a>
                </div>
              </div>
            </div> */}

            <div className="pc-h-item d-none d-md-inline-flex align-items-center me-2">
              <div className="text-end" style={{ lineHeight: "1.3", marginRight: "10px" }}>
                <h6 className="mb-0 text-dark" style={{ fontSize: "0.85rem", fontWeight: "600" }}>
                  {user?.firstName} {user?.lastName}
                </h6>
                <small className="text-muted" style={{ fontSize: "0.75rem", display: "block" }}>
                  {user?.roleName} | ID: {user?.loginId || "N/A"}
                </small>
              </div>
            </div>

            <div className="pc-h-item dropdown" ref={notifRef}>

  {/* 🔔 Bell Icon */}
  <button
    type="button"
    className="pc-head-link me-0 btn btn-link"
    onClick={() => setNotifOpen(prev => !prev)}
  >
    <i className="ph ph-bell" />
    <span className="badge bg-success pc-h-badge">
      {notifications.length}
    </span>
  </button>

  {/* 🔥 SAME LIKE LOGOUT POPUP */}
  <div
    className={`dropdown-user-profile pc-h-dropdown p-0 overflow-hidden dropdown-menu dropdown-menu-end ${notifOpen ? "show" : ""}`}
    style={{
      position: "absolute",
      inset: "0px 0px auto auto",
      transform: "translate3d(-24px, 60px, 0px)",
      width: "500px",
      maxWidth: "none"
    }}
  >
    <div className="bg-primary dropdown-header">
      <h6 className="text-white mb-0">Notifications</h6>
    </div>

    <div className="dropdown-body">
      <div style={{ maxHeight: "150px", overflowY: "auto" }}>

        {notifications.length === 0 ? (
          <p className="text-center p-2">No notifications</p>
        ) : (
          notifications.map((item) => (
            <div key={item.id} className="p-2 border-bottom">

              {/* ✅ MESSAGE */}
              <h6 className="mb-1">{item.title}</h6>
              <p className="mb-1">{item.message}</p>

              {/* ✅ SCREEN NAME */}
              <small className="text-muted">
                Screen: {item.screenName || "N/A"}
              </small>
              <br />

              {/* ✅ USER */}
              <small className="text-muted">
                To User: {item.employeeName || "N/A"}
              </small>
              <br />

              {/* ✅ DATE */}
              <small className="text-muted">
                {new Date(item.createdDate).toLocaleString()}
              </small>

            </div>
          ))
        )}

      </div>
    </div>
  </div>

</div>
            <div className="pc-h-item dropdown" ref={profileRef}>
              <button
                type="button"
                id="user-profile-dropdown"
                aria-expanded="false"
                aria-haspopup="true"
                className="pc-head-link arrow-none me-0 dropdown-toggle btn btn-link"
                onClick={() => setProfileOpen(prev => !prev)}
              >
                <i className="ph ph-user-circle" />
              </button>
              <div
                id="userProfileMenu"
                x-placement="bottom-end"
                aria-labelledby="user-profile-dropdown"
                className={`dropdown-user-profile pc-h-dropdown p-0 overflow-hidden dropdown-menu dropdown-menu-end ${profileOpen ? "show" : ""
                  }`}
                data-popper-reference-hidden="false"
                data-popper-escaped="false"
                data-popper-placement="bottom-end"
                style={{
                  position: "absolute",
                  inset: "0px 0px auto auto",
                  transform: "translate3d(-24.8889px, 1031.11px, 0px)",
                }}
              >
                <div className="bg-primary dropdown-header" role="heading">
                  <div className="my-2 hstack gap-3">
                    <div className="flex-shrink-0">
                      <img
                        src="/demos/admin-templates/datta-able/react/free/src/assets/images/user/avatar-2.png"
                        alt="user-avatar"
                        className="user-avatar wid-35 rounded-circle"
                      />
                    </div>
                    <div className="vstack gap-1">
                      <h6 className="text-white mb-0">{user?.firstName} {user?.lastName}🖖</h6>
                      <span className="text-white text-opacity-75">
                        {user?.emailId}
                      </span>
                      <span className="text-white text-opacity-75">
                        {user?.roleName}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="dropdown-body">
                  <div
                    className="profile-notification-scroll position-relative"
                    style={{ maxHeight: "calc(-225px + 100vh)" }}
                  >
                    {(roleId === 1 || roleId === "1") &&
                      <a
                        data-rr-ui-dropdown-item=""
                        className="justify-content-start dropdown-item"
                        href="#"
                        data-discover="true"
                      >
                        <i className="ph ph-share-network me-2" />
                        Switch Company
                      </a>
                    }
                    <a
                      data-rr-ui-dropdown-item=""
                      className="justify-content-start dropdown-item"
                      href="#"
                      data-discover="true"
                      onClick={handleChangePassword}
                    >
                      <i className="ph ph-lock-key me-2" />
                      Change Password
                    </a>
                    <div className="d-grid my-2">
                      <button type="button" className="btn btn-primary"
                        onClick={handleLogout}>
                        <i className="ph ph-sign-out align-middle me-2" />
                        Logout
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </header>
  );
}
